import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/About.css';

function About() {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1>Sobre MARCUS Security</h1>
          <p>Compromiso con la seguridad desde 2013</p>
        </div>
      </section>

      {/* Company Intro */}
      <section className="company-intro">
        <div className="container">
          <div className="intro-content">
            <div className="intro-text">
              <span className="section-tag">Quiénes Somos</span>
              <h2>Empresa Chilena de Seguridad Privada</h2>
              <p className="lead">Marcus Security es una empresa chilena de seguridad privada, fundada en 2013 en la Región Metropolitana por el ex Coronel de Carabineros Alejandro Salinas Carvajal, con más de 30 años de experiencia institucional.</p>
              
              <p>Somos una empresa conformada por un grupo de profesionales cuyo principal objetivo es dar soluciones a problemáticas que puedan afectar la operatividad de nuestros clientes, logrando mediante la aplicación de controles en los procesos, proteger su integridad.</p>

              <p>Realizamos nuestros servicios bajo altos estándares internacionales, basados en Normas ISO, leyes y decretos nacionales, además de contar en nuestro equipo con expertos asesores certificados en seguridad privada, con gran experiencia captada en base a los años dedicados a nuestro giro.</p>

              <p>Actualmente brindamos servicios en las Regiones Metropolitana, de Valparaíso y de Antofagasta, con clientes de prestigio nacional e internacional.</p>
            </div>

            <div className="intro-image">
              <img src="/images/about-company.png" alt="MARCUS Security" />
              <div className="stats-overlay">
                <div className="stat">
                  <span className="stat-number">12+</span>
                  <span className="stat-label">Años de Experiencia</span>
                </div>
                <div className="stat">
                  <span className="stat-number">2013</span>
                  <span className="stat-label">Año de Fundación</span>
                </div>
                <div className="stat">
                  <span className="stat-number">3</span>
                  <span className="stat-label">Regiones de Operación</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section id="mision-vision" className="mission-vision">
        <div className="container">
          <div className="mv-grid">
            <div className="mv-card">
              <div className="mv-icon">
                <img src="/images/icons/mission-icon.png" alt="Misión" />
              </div>
              <h3>Nuestra Misión</h3>
              <p>Ofrecer soluciones de forma integral, eficiente y personalizada, adaptadas a las necesidades de cada cliente, garantizando seguridad y confianza en cada servicio.</p>
            </div>

            <div className="mv-card">
              <div className="mv-icon">
                <img src="/images/icons/vision-icon.png" alt="Visión" />
              </div>
              <h3>Nuestra Visión</h3>
              <p>Ser una empresa líder a nivel nacional en seguridad privada y tecnológica, reconocida por su profesionalismo, innovación y compromiso con las personas y organizaciones.</p>
            </div>

            <div className="mv-card">
              <div className="mv-icon">
                <img src="/images/icons/values-icon.png" alt="Valores" />
              </div>
              <h3>Nuestros Valores</h3>
              <ul className="values-list">
                <li>Compromiso</li>
                <li>Profesionalismo</li>
                <li>Transparencia</li>
                <li>Confianza</li>
                <li>Innovación</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Filosofía Empresarial */}
      <section className="mission-statement">
        <div className="container">
          <h2>Nuestra Filosofía</h2>
          <div className="philosophy-content">
            <p className="lead-text">Nos mueve la idea de que implementando cambios estratégicos en las organizaciones, apoyados en la legislación vigente, se puede mejorar el comportamiento ético de las personas, lo que contribuye a un mayor desarrollo económico y social de nuestro país.</p>
          </div>
        </div>
      </section>

      {/* Certificaciones */}
      <section id="certificaciones" className="certifications">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Autorizaciones Oficiales</span>
            <h2>Certificaciones y Acreditaciones</h2>
          </div>

          <div className="cert-content">
            <div className="cert-badge-large">
              <img src="/images/os10-certification.png" alt="Certificación OS10" />
            </div>

            <div className="cert-text">
              <h3>Autorización OS10 - Carabineros de Chile</h3>
              <p><strong>Razón Social:</strong> Salinas y Bensa Seguridad Privada SPA</p>
              <p><strong>RUT:</strong> 76.261.664-5</p>
              
              <div className="auth-details">
                <h4>Autorizaciones</h4>
                <ul>
                  <li><strong>Empresa:</strong> Número 0805xxxxxxx (Carabineros de Chile - OS10)</li>
                  <li><strong>Asesor:</strong> Alejandro Salinas Carvajal</li>
                </ul>
              </div>

              <div className="specialties-grid">
                <div className="specialty-item">
                  <span className="specialty-icon">
 
                  </span>
                  <span className="specialty-text">Servicios de Recursos Humanos</span>
                </div>
                <div className="specialty-item">
                  <span className="specialty-icon">

                  </span>
                  <span className="specialty-text">Asesorías en Seguridad</span>
                </div>
              </div>

              <div className="cert-benefits">
                <h4>Seguros y Resguardo Legal</h4>
                <ul>
                  <li><strong>Seguro de Responsabilidad Civil:</strong> Hasta 1.000 UF (HDI Seguros)</li>
                  <li><strong>Seguro de Vida:</strong> Todos los guardias (HDI Seguros)</li>
                  <li><strong>Afiliación ACHS:</strong> Atención inmediata ante accidentes laborales o de trayecto</li>
                  <li>Personal uniformado con equipo de radiocomunicación</li>
                  <li>Fiscalización periódica por parte de Carabineros de Chile</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipo Directivo */}
      <section className="leadership">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Nuestro Equipo</span>
            <h2>Equipo Directivo</h2>
            <p>Profesionales con vasta experiencia en seguridad pública y privada</p>
          </div>

          <div className="team-grid-top">
            <div className="team-member">
              <div className="member-image">
                <img src="/images/team-constanza-sepulveda.jpeg" alt="Constanza Sepúlveda" />
              </div>
              <h3>Constanza Sepúlveda Rodríguez</h3>
              <p className="member-role">Gerente General y Representante Legal</p>
              <p className="member-bio">Dirección general de la empresa, responsable de la estrategia corporativa y representación legal ante autoridades.</p>
              <a href="mailto:csepulveda@marcussecurity.cl" className="member-contact"></a>
            </div>

            <div className="team-member">
              <div className="member-image">
                <img src="/images/team-alejandro-salinas.jpeg" alt="Alejandro Salinas Carvajal" />
              </div>
              <h3>Alejandro Salinas Carvajal</h3>
              <p className="member-role">Asesor de Seguridad / Fundador</p>
              <p className="member-bio">Ex Coronel de Carabineros con más de 30 años de experiencia institucional. Gerente de Administración y estrategia de la empresa.</p>
              <a href="mailto:asalinas@marcussecurity.cl" className="member-contact">asalinas@marcussecurity.cl</a>
            </div>

            <div className="team-member">
              <div className="member-image">
                <img src="/images/team-rossana-bensa.jpeg" alt="Rossana Bensa" />
              </div>
              <h3>Rossana Bensa Campos</h3>
              <p className="member-role">Gerente Comercial</p>
              <p className="member-bio">Gestión comercial, desarrollo de negocios y atención estratégica a clientes corporativos.</p>
              <a href="mailto:rbensa@marcussecurity.cl" className="member-contact">rbensa@marcussecurity.cl</a>
            </div>
          </div>

          <div className="team-grid-bottom">
            <div className="team-member">
              <div className="member-image">
                <img src="/images/team-alejandro-salinas-bensa.jpeg" alt="Alejandro Salinas Bensa" />
              </div>
              <h3>Alejandro Salinas Bensa</h3>
              <p className="member-role">Jefe de Seguridad Santiago</p>
              <p className="member-bio">Supervisión y coordinación de operaciones de seguridad en la Región Metropolitana.</p>
              <a href="mailto:asbensa@marcussecurity.cl" className="member-contact">asbensa@marcussecurity.cl</a>
            </div>

            <div className="team-member">
              <div className="member-image">
                <img src="/images/team-cristobal-salinas.jpeg" alt="Cristóbal Salinas Bensa" />
              </div>
              <h3>Cristóbal Salinas Bensa</h3>
              <p className="member-role">Jefe de Operaciones Viña del Mar</p>
              <p className="member-bio">Coordinación de operaciones y gestión del personal de seguridad en la Región de Valparaíso.</p>
              <a href="mailto:cristobalsalinas@marcussecurity.cl" className="member-contact">cristobalsalinas@marcussecurity.cl</a>
            </div>
          </div>

          <div className="additional-team">
            <h3>Equipo de Soporte</h3>
            <div className="support-grid">
              <div className="support-member">
                <h4>Jonathan Aguilar</h4>
                <p>Contador</p>
              </div>
              <div className="support-member">
                <h4>Maricela Álvarez Pino</h4>
                <p>Experto en Prevención de Riesgos ACHS</p>
              </div>
              <div className="support-member">
                <h4>José Gómez Mella</h4>
                <p>Abogado</p>
              </div>
              <div className="support-member">
                <h4>Andrés Emeric</h4>
                <p>Asesor Administración de Finanzas</p>
              </div>
              <div className="support-member">
                <h4>Javier Balcázar Gutiérrez</h4>
                <p>Jefe de Operaciones Antofagasta (Enjoy)</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Clientes */}
      <section id="clientes" className="clients-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Confían en Nosotros</span>
            <h2>Nuestros Clientes</h2>
            <p>Empresas e instituciones de diversos sectores que confían en nuestro servicio</p>
          </div>

          <div className="clients-showcase">
            <div className="client-card">
              <div className="client-logo-large">
                <img src="/images/logo-enjoy.png" alt="Enjoy Casino" />
              </div>
              <h3>Enjoy</h3>
              <p>Casino y Resort - Viña del Mar y Antofagasta</p>
            </div>

            <div className="client-card">
              <div className="client-logo-large">
                <img src="/images/logo-gam.png" alt="Centro Cultural GAM" />
              </div>
              <h3>Centro Cultural GAM</h3>
              <p>Centro Cultural Gabriela Mistral - Santiago</p>
            </div>

            <div className="client-card">
              <div className="client-logo-large">
                <img src="/images/logo-santa-fe.png" alt="Grupo Santa Fe" />
              </div>
              <h3>Grupo Santa Fe</h3>
              <p>Grupo inmobiliario con presencia en todo Chile</p>
            </div>

            <div className="client-card">
              <div className="client-logo-large">
                <img src="/images/logo-karun.png" alt="Karün" />
              </div>
              <h3>Karün</h3>
              <p>Empresa de anteojos sustentables</p>
            </div>

            <div className="client-card">
              <div className="client-logo-large">
                <img src="/images/logo-lo-valledor.png" alt="Mercado Lo Valledor" />
              </div>
              <h3>Mercado Lo Valledor</h3>
              <p>Mercado Mayorista - Santiago</p>
            </div>

            <div className="client-card">
              <div className="client-logo-large">
                <img src="/images/logo-rotter-krauss.png" alt="Rotter & Krauss" />
              </div>
              <h3>Rotter & Krauss</h3>
              <p>Empresa de iluminación y ferretería</p>
            </div>
          </div>

          <div className="additional-clients">
            <h3>También confían en nosotros</h3>
            <div className="client-list">
              <span>BredenMaster</span>
              <span>CHUBB Seguros Chile</span>
              <span>CAPUAL</span>
              <span>Condominio Gran Océano</span>
              <span>CBRE</span>
              <span>RedSalud CChC</span>
            </div>
          </div>

          <div className="client-sectors">
            <h3>Sectores que Atendemos</h3>
            <div className="sectors-grid">
              <div className="sector-item">
                <span className="sector-icon">🏢</span>
                <span>Edificios Corporativos</span>
              </div>
              <div className="sector-item">
                <span className="sector-icon">🎰</span>
                <span>Casinos y Entretenimiento</span>
              </div>
              <div className="sector-item">
                <span className="sector-icon">🏬</span>
                <span>Centros Comerciales</span>
              </div>
              <div className="sector-item">
                <span className="sector-icon">🏘️</span>
                <span>Condominios</span>
              </div>
              <div className="sector-item">
                <span className="sector-icon">🎭</span>
                <span>Centros Culturales</span>
              </div>
              <div className="sector-item">
                <span className="sector-icon">🏭</span>
                <span>Industrias</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta">
        <div className="container">
          <h2>¿Quieres Ser Parte de Nuestra Historia?</h2>
          <p>Únete a las empresas que confían en Marcus Security para proteger lo que más valoran</p>
          <Link to="/contacto" className="btn btn-primary">Contáctanos Hoy</Link>
        </div>
      </section>
    </div>
  );
}

export default About;